import { getAPICall, postAPICall, getAPICallWithParams } from './BaseAPI';

export const createPenalty = (payload, cb=(jR, s, e)=>{}) => {
  postAPICall('vr/penalties/create', payload, cb);
}

export const getPenaltyRules = async (params = {}, cb = (jR, s, e) => {}) => {
  return await getAPICallWithParams('vr/penalties/rules', params, cb);
}

export const createPenaltyRule = (payload, cb = (jR, s, e) => {}) => {
  postAPICall('vr/penalties/rules/create', payload, cb);
}

export const updatePenaltyRule = (payload, cb = (jR, s, e) => {}) => {
  postAPICall('vr/penalties/rules/update', payload, cb);
}

export const deletePenaltyRule = (payload, cb = (jR, s, e) => {}) => {
  postAPICall('vr/penalties/rules/delete', payload, cb);
}